import React from "react";
import { GraduationCap, Award } from "lucide-react";
import "../styles/Education.css";

const educationData = [
  {
    degree: "Bachelor of Engineering (Computer Science)",
    institution: "Padre Conceicao College of Engineering, Goa",
    period: "2022 – 2026",
    score: "CGPA: 9.0",
    highlights: ["AIML Honors Track", "Active in hackathons & tech events", "Strong academic performance"],
  },
  {
    degree: "Higher Secondary (XII)",
    institution: "Father Agnel's School, Verna",
    period: "2020 – 2022",
    score: "Percentage: 75.66%",
    highlights: ["Science stream", "Foundation in mathematics & computing"],
  },
  {
    degree: "Secondary (X)",
    institution: "St. Anthony's High School, Majorda",
    period: "2019 – 2020",
    score: "Percentage: 81.83%",
    highlights: ["Strong academics", "Sports achievements"],
  },
];

const Education = () => {
  return (
    <section className="education">
      <div className="education-header">
        <p className="education-label">Academic Background</p>
        <h2>Education</h2>
        <p className="education-subtitle">
          A strong academic foundation in computer science with hands-on experience through projects and competitions.
        </p>
      </div>

      <div className="education-cards">
        {educationData.map((edu, index) => (
          <div className="education-card" key={index}>
            <div className="education-card-icon">
              <GraduationCap size={24} />
            </div>
            <div className="education-card-content">
              <div className="education-card-top">
                <h3>{edu.degree}</h3>
                <span className="education-period">{edu.period}</span>
              </div>
              <p className="education-institution">{edu.institution}</p>
              <div className="education-score">
                <Award size={14} />
                <span>{edu.score}</span>
              </div>
              <ul className="education-highlights">
                {edu.highlights.map((h, i) => (
                  <li key={i}>{h}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Education;
